//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetPlatforms = () =>
    request({
        url: ApiURL.Query.GetPlatforms,
        method: RequestType.GET,
    });

const GetCountryList = () =>
    request({
        url: ApiURL.Query.GetCountryList,
        method: RequestType.GET,
    });

const MasterDataQuery = {
    GetPlatforms,
    GetCountryList,
};

export default MasterDataQuery;
